'use client'

import { StatusPanel } from '@/components/status/status-panel'

/**
 * The app's 404. Without it a mistyped or outdated link landed on Next's bare
 * "404 This page could not be found" — black text on white, English only, no
 * way back. Now it is the product's own page: the 404 picture, the words in
 * the reader's language, "Back to Home" to the area's own front page (the
 * dashboard; the portal for a learner) and "Go back".
 *
 * A client component so the panel can read the saved language and the
 * address; it renders inside the root layout's providers.
 */
export default function NotFound() {
  return (
    <main className="flex min-h-svh w-full flex-col bg-background">
      <StatusPanel kind="404" variant="page" />
    </main>
  )
}
